import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChevronRight,
  faArrowDownArrowUp
} from '@fortawesome/pro-regular-svg-icons';

import { VideoModalComponent } from "@shared/video-modal/video-modal.component";
import { AgentsAddSimpleModalComponent } from "@shared/agents-add-simple-modal/agents-add-simple-modal.component";
import { PlatformUserCardComponent } from "@shared/platform-user-card/platform-user-card.component";
import { LoaderComponent } from "@shared/loader/loader.component";
import { Router } from '@angular/router';
import { ProfileMenuComponent } from '@shared/profile-menu/profile-menu.component';
import { HomeExpertsSectionComponent } from './components/home-experts-section.component';
import { HomeCompanySummaryComponent } from './components/home-company-summary.component';
import { HomeConnectionsSectionComponent } from './components/home-connections-section.component';
import { HomeRecentChatsSectionComponent } from './components/home-recent-chats-section.component';
import { HomeHeroSectionComponent } from './components/home-hero-section.component';
import { HomeFacade } from './home.facade';
import { HomePlatformUsersFacade } from './home-platform-users.facade';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [HomeFacade, HomePlatformUsersFacade],
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    VideoModalComponent,
    AgentsAddSimpleModalComponent,
    PlatformUserCardComponent,
    LoaderComponent,
    ProfileMenuComponent,
    HomeHeroSectionComponent,
    HomeExpertsSectionComponent,
    HomeCompanySummaryComponent,
    HomeConnectionsSectionComponent,
    HomeRecentChatsSectionComponent,
  ]
})
export class HomeComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  modalVideoUrl = '';
  showModal = false;
  showAddExpertModal = false;

  // FontAwesome Icons
  faChevronRight = faChevronRight;
  faArrowDownArrowUp = faArrowDownArrowUp;

  constructor(
    public home: HomeFacade,
    public platformUsersFacade: HomePlatformUsersFacade,
    private router: Router
  ) {}


  ngOnInit(): void {
    this.home.init();

    // Uso de la plataforma
    this.platformUsersFacade.loadPlatformUsers();
  }

  // ---------- Novedades ARDIA ----------

  goToUserManagement(): void {
    this.router.navigate(['/dashboard/settings/users']);
  }

  goToCompanyContext(): void {
    // Supervisor/Superadmin → configuración/mi empresa; Usuario → mi empresa directa
    if (this.home.isAdmin) {
      this.router.navigate(['/dashboard/settings/company']);
    } else {
      this.router.navigate(['/dashboard/company']);
    }
  }

  goToFormacion() {
    this.router.navigate(['/dashboard/training']);
  }

  // Navegar a la página de todos los agentes
  goToAgents() {
    this.router.navigate(['/dashboard/agents']);
  }

  ngOnDestroy(): void {
    this.home.destroy();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openVideoModal(url: string) {
    this.modalVideoUrl = url;
    this.showModal = true;
  }

  closeVideoModal() {
    this.showModal = false;
    this.modalVideoUrl = '';
  }

  openAddExpertModal() {
    this.showAddExpertModal = true;
  }

  closeAddExpertModal() {
    this.showAddExpertModal = false;
  }

  onAgentCreated(event: any) {
    this.showAddExpertModal = false;
    // Los agentes se recargarán automáticamente a través del AgentStateService
  }
}
